module.exports = __webpack_public_path__ + "img/handraw_paiement blanc.0c508b78.svg";